import { useTranslate } from 'ra-core'
import { FC } from 'react'
import { TextInput } from 'react-admin'
import InputAccordion from '../common/InputAccordion'
import { validateElfsightWidgetLink } from '../form'
import { useBlockSource } from '../useBlockSource'

interface PropTypes {
  disabled?: boolean
}

const SocialsFields: FC<PropTypes> = ({ disabled }) => {
  const translate = useTranslate()
  const source = useBlockSource('socials')

  if (!source) return null
  return (
    <InputAccordion title={translate('Socials')} source={source}>
      <span>{translate('Configure a dedicated Elfsight LinkedIn widget to appear in your Expo Stand.')}</span>
      <TextInput
        label={'Elfsight Widget Link'}
        name={`${source}.widgetLink`}
        source={`${source}.widgetLink`}
        disabled={disabled}
        validate={validateElfsightWidgetLink}
      />
    </InputAccordion>
  )
}

export default SocialsFields
